import React, { FC } from 'react'

interface SVGRedirectProps {
  width?: string;
  height?: string;
  color?: string;
  strokeWidth?: string;
}

const SVGRedirect: FC<SVGRedirectProps> = ({ width = '20', height = '21', color = '#6140FF', strokeWidth = '1.66667' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 11.3618V16.3618C15 16.8038 14.8244 17.2277 14.5118 17.5403C14.1993 17.8528 13.7754 18.0284 13.3333 18.0284H4.16667C3.72464 18.0284 3.30072 17.8528 2.98816 17.5403C2.67559 17.2277 2.5 16.8038 2.5 16.3618V7.19511C2.5 6.75308 2.67559 6.32916 2.98816 6.0166C3.30072 5.70404 3.72464 5.52844 4.16667 5.52844H9.16667" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.5 3.02844H17.5V8.02844" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.33337 12.1951L17.5 3.02844" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default SVGRedirect